<label class="mb-2 block text-body-sm-600 text-surface-700" [for]="inputId()">{{ label() }}</label>

<input
  pInputText
  pSize="small"
  type="text"
  class="w-full"
  placeholder="0 9,12,17 * * *"
  spellcheck="false"
  autocomplete="off"
  [id]="inputId()"
  [formControl]="control()"
  [invalid]="control().invalid"
  (blur)="commit.emit()"
  (keyup.enter)="commit.emit()"
/>

@if (control().invalid) {
  <p class="m-0 mt-2 text-body-xs text-red-600">
    Enter five space-separated fields: minute, hour, day of month, month, day of week.
  </p>
} @else if (description()) {
  <p class="m-0 mt-2 text-body-xs-600 text-surface-600">{{ description() }}</p>
}
